import { render, staticRenderFns } from "./UserSidebar.vue?vue&type=template&id=a0062bca&scoped=true"
import script from "./UserSidebar.vue?vue&type=script&lang=js"
export * from "./UserSidebar.vue?vue&type=script&lang=js"
import style0 from "./UserSidebar.vue?vue&type=style&index=0&id=a0062bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0062bca",
  null
  
)

export default component.exports